import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=4afb79c2&scoped=true&"
import script from "./Place.vue?vue&type=script&lang=ts&"
export * from "./Place.vue?vue&type=script&lang=ts&"
import style0 from "./Place.vue?vue&type=style&index=0&id=4afb79c2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb79c2",
  null
  
)

export default component.exports